import { LOCALE_ID, NgModule } from '@angular/core';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { SharedModule } from '@shared/shared.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthTokenInterceptor } from '@core/api/auth-token.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-MX';
import { BodyLoadingInterceptor } from '@core/api/body-loading-interceptor/body.loading.interceptor';
import { WsSelectorIaBinding } from '@features/shared/ws-selector-ia';

registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor, // Agrega el nuevo interceptor aquí
      multi: true,
    },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        disableTooltipInteractivity: true,
      },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BodyLoadingInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'es-MX' },
    ...WsSelectorIaBinding,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
